import { Grid, Typography } from "@mui/material";
import React from "react";

const Header = () => {
  return (
    <Grid
      // component="header"
      role='main'
      aria-labelledby="energy-star-most-efficient-heading"
      textAlign="left"
      marginBottom="2.5rem"
    >
      <Typography
        aria-label={"ENERGY STAR Most Efficient "+import.meta.env.VITE_MOSTEFFICIENTYEAR}
        variant="h1"
        component="h1"
        fontSize="clamp(1.80203125rem, 1.4392078629rem + 1.6125483871vw, 3.05175625rem)"
        fontWeight="700"
        line-height="1.1"
        display="block"
        margin="0 0 1.125rem"
      >
        ENERGY STAR Most Efficient {import.meta.env.VITE_MOSTEFFICIENTYEAR}
      </Typography>
    </Grid>
  );
};

export default Header;
